<template>
  <ContactNative />

  <!-- 将精彩评论和全部评论做视觉上的合并（浏览器8.0），其它逻辑如排序保持不变 -->
  <h4 v-if="isArticle" ref="titleBar" class="comments-name" :class="newTitleClass">精彩评论</h4>

  <Announcement v-if="canShowAnnouncement" />

  <!-- <TopicCard v-if="enableTopicCard" /> -->

  <section
    v-if="
      commentStatus == CommentStatus.DEFAULT || commentStatus == CommentStatus.SHOW_BUT_NO_REPLY
    "
    ref="commentZone"
    class="comment-zone"
  >
    <!-- <TopicEntry
      v-if="enableTopicEntry && topComments.length > 0"
      :autoplay="true"
      :time="3000"
      :class="hideTitleMarginTopClass"
    /> -->

    <CommentAnnouncement v-if="commentStatus == CommentStatus.DEFAULT && topComments.length > 0" />

    <!-- <CommentAssistant :is-current-index="standLocation === 0 && topComments.length > 0" /> -->

    <ul v-if="topComments.length > 0" id="top-comments-list" class="comments-list">
      <AdSlot
        id="comment_0"
        type="hot"
        :index="0"
        :list-size="topComments.length"
        :total="topCommentCount"
        :load-status="topLoadStatus"
      />

      <div
        v-for="(item, index) in topComments"
        :id="`comment_${item.id}`"
        :key="`topComment${item.id}`"
        class="comment-item"
      >
        <CommentItem type="hot" :index="index + 1" :item-data="item" />

        <AdSlot
          :id="`comment_${item.id}`"
          type="hot"
          :index="index + 1"
          :list-size="topComments.length"
          :total="topCommentCount"
          :load-status="topLoadStatus"
        />
        <!-- <CommentAssistant :is-current-index="index === standLocation - 1 && standLocation > 0" /> -->
      </div>
    </ul>

    <!-- <TopicEntry
      v-if="enableTopicEntry && topComments.length === 0"
      :autoplay="true"
      :time="3000"
      :class="hideTitleMarginTopClass"
    /> -->

    <!-- <CommentAssistant :is-current-index="standLocation === 0 && topComments.length > 0" /> -->

    <CommentAnnouncement
      v-if="commentStatus == CommentStatus.DEFAULT && topComments.length === 0"
    />

    <ul v-if="newComments.length > 0" id="new-comments-list" class="comments-list">
      <AdSlot
        id="comment_0"
        type="new"
        :index="0"
        :list-size="newComments.length"
        :total="newCommentCount"
        :load-status="newLoadStatus"
      />

      <div
        v-for="(item, index) in newComments"
        :id="`comment_${item.id}`"
        :key="`comment_${item.id}`"
      >
        <CommentItem type="new" :index="index + 1" :item-data="item" />

        <AdSlot
          :id="`comment_${item.id}`"
          type="new"
          :index="index + 1"
          :list-size="newComments.length"
          :total="newCommentCount"
          :load-status="newLoadStatus"
        />
        <!-- <CommentAssistant
          :is-current-index="index + topComments.length === standLocation - 1 && standLocation > 0"
        /> -->
      </div>
    </ul>
    <!-- <CommentAssistant
      :is-current-index="
        topComments.length + newComments.length <= standLocation - 1 && standLocation > 0
      "
    /> -->

    <div class="load-bar" :style="commentBarStyle">
      <div v-if="!isNoContent" class="load-bar-normal">
        <ScrollLoadMore
          class="scroll-load-more"
          :distance="1.5"
          @update:load-more="fetchCommentStat"
        >
          <div v-if="newLoadStatus == LoadStatus.LOADING">
            <p class="load-txt load-foot">正在加载...</p>
          </div>

          <div v-else-if="newLoadStatus == LoadStatus.LOADCOMPLETED && newCommentCount > 0">
            <p class="load-txt load-foot">无更多内容</p>
          </div>

          <div v-else-if="newLoadStatus == LoadStatus.POOR_NETWORK">
            <p class="load-text">网络信号差，请重试</p>
          </div>

          <div v-else-if="newLoadStatus == LoadStatus.NO_CONNECTION">
            <!-- <div class="no-network-connection"></div> -->
            <DynamicGraph :lottie-json="noConnectionLottie" :is-full-height="false" />
            <p class="load-text">无网络连接</p>
          </div>

          <div v-else-if="newLoadStatus == LoadStatus.NO_SERVICE">
            <p class="load-text">服务器异常，请上划重试</p>
          </div>

          <div v-else-if="newLoadStatus == LoadStatus.DEFAULT">
            <p class="load-txt load-foot">正在加载...</p>
          </div>
        </ScrollLoadMore>
      </div>

      <div v-else :class="isArticle ? 'load-bar-nothing' : ''">
        <div
          v-if="
            newLoadStatus == LoadStatus.LOADERROR ||
            newLoadStatus == LoadStatus.NO_SERVICE ||
            newLoadStatus == LoadStatus.NO_CONNECTION ||
            newLoadStatus == LoadStatus.POOR_NETWORK
          "
          @click.stop="fetchCommentStat(true)"
        >
          <div v-if="!isLoading">
            <!-- <div class="load-retry"></div> -->
            <DynamicGraph :lottie-json="loadingErrorLottie" :is-full-height="false" />
            <p class="load-txt">加载失败</p>
            <p class="retry-txt">重试</p>
          </div>
          <div v-else class="sdk-load-loading">
            <div class="load-loading-icon"></div>
            <p class="load-loading-txt">正在加载...</p>
          </div>
        </div>

        <div v-else-if="newLoadStatus == LoadStatus.LOADING" class="sdk-load-loading">
          <div class="load-loading-icon" />
          <p class="load-loading-txt">正在加载...</p>
        </div>

        <div
          v-else-if="newLoadStatus == LoadStatus.LOADCOMPLETED"
          @click.stop="addCommentHandler({ commentId: '', replyId: '', owner: { nickname: '' } })"
        >
          <NoCommentTip />
        </div>
      </div>
    </div>
  </section>

  <div v-else class="load-bar" :style="noCommentStyle">
    <NoCommentTip />
  </div>
</template>

<script lang="ts">
import {
  computed,
  onMounted,
  ref,
  defineComponent,
  defineAsyncComponent,
  watch,
  toRefs,
} from 'vue';
import wv, { getCommentSwitchStatus } from '@cpc/comment-sdk-jsapi';
import { constant, utils } from '@cpc/comment-sdk-common';
import { useIsInViewPort } from '@cpc/comment-sdk-core';
import {
  useCommentListInject,
  useCommentList,
  useGlobalState,
  useAnnouncement,
  useNativeAbility,
  useAnchorSliding,
  useStat,
} from '@cpc/comment-sdk-core-comment';
import { useDebounceFn } from '@vueuse/core';
import * as feedsModuleController from '@cpc/lib-feeds-module-controller';

import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { useBrowserVersion } from '../core/useBrowserVersion';
import { commonCommentStat } from '../core/useStat';
import { useCommentScene } from '../core/useCommentScene';
import { useOsVersionLottie } from '../core/useOsVersionLottie';
import loadingError from '../assets/lottie/loading-light.json?url';
import loadingErrorDark from '../assets/lottie/loading-dark.json?url';
import noConnection from '../assets/lottie/no-connection-light.json?url';
import noConnectionDark from '../assets/lottie/no-connection-dark.json?url';

// os16动画
import os16LoadingError from '../assets/lottie/os16/loading-light.json?url';
import os16LoadingErrorDark from '../assets/lottie/os16/loading-dark.json?url';
import os16NoConnection from '../assets/lottie/os16/no-connection-light.json?url';
import os16NoConnectionDark from '../assets/lottie/os16/no-connection-dark.json?url';

import ScrollLoadMore from './ScrollLoadMore.vue';
import ContactNative from './ContactNative.vue';

export default defineComponent({
  name: 'CommentList',

  components: {
    // CommentAssistant: defineAsyncComponent(() => import('./Assistant.vue')),
    CommentItem: defineAsyncComponent(() => import('./CommentItem.vue')),
    ScrollLoadMore,
    AdSlot: defineAsyncComponent(() => import('./AdSlot.vue')),
    ContactNative,
    Announcement: defineAsyncComponent(() => import('./Announcement.vue')),
    CommentAnnouncement: defineAsyncComponent(() => import('./CommentAnnouncement.vue')),
    DynamicGraph: defineAsyncComponent(() => import('./DynamicGraph.vue')),
    NoCommentTip: defineAsyncComponent(() => import('./NoCommentTip.vue')),
    // TopicCard: defineAsyncComponent(() => import('./TopicCard.vue')),
    // TopicEntry: defineAsyncComponent(() => import('./TopicEntry.vue')),
  },

  props: {},

  setup() {
    const { LoadStatus, CommentStatus, PageType } = constant;

    const { getStyleType, $ } = utils;

    const {
      newComments,
      newLoadStatus,
      newCommentCount,

      topComments,
      topLoadStatus,
      topCommentCount,

      setNewCount,

      commentTotal,

      // 耗时
      commonCostTime,
    } = useCommentListInject();

    const { fetchComments, enableUsePreloadList } = useCommentList();
    const { documentMeta, pageType, commentStatus, isNightMode } = toRefs(useGlobalState());

    const { getColorOsVersion } = useBrowserVersion();

    const { onAnchorSliding, isPosVisible } = useAnchorSliding();

    // listenSelectorAll([
    //   { seletors: ['.load-send-comment'], attrs: ['fontColor'], isImportant: true },
    // ]);

    const { onComment, sendCommentCount } = useOnCommentClickInject();

    const { isShowAnnoucement } = useAnnouncement();

    const postItemHeight = ref(0);

    // const standLocation = ref(-1);

    const contentType = getStyleType();

    const { limitedCommentScene } = useCommentScene();

    const { getVersionLottieResource } = useOsVersionLottie();

    const isLoading = ref(false);

    // 获取评论列表埋点
    commonCommentStat(20084680);

    onMounted(() => {
      const durationTime = window.__TEMPLATE_COMMEMT_DATA__?.startTime
        ? Date.now() - window.__TEMPLATE_COMMEMT_DATA__.startTime
        : window.performance.now();

      const source = documentMeta.value.dataSource === 'yidian' ? 'yidian' : '';
      const commentScene = documentMeta.value.styleType === 1 ? 'detail' : 'comment-list';
      if (feedsModuleController?.getModulesConfig || window.getModulesConfig) {
        window.moduleAdConfig = (
          feedsModuleController?.getModulesConfig || window.getModulesConfig
        )(
          { isGovArticle: false },
          commentScene,
          newCommentCount.value + topCommentCount.value,
          source,
        );
      }

      window.generalPerfStat?.({ action: 'requestStart', durationTime });

      fetchComments()
        .then(() => {
          if (feedsModuleController?.getModulesConfig || window.getModulesConfig) {
            window.moduleAdConfig = (
              feedsModuleController?.getModulesConfig || window.getModulesConfig
            )(
              { isGovArticle: false },
              commentScene,
              newCommentCount.value + topCommentCount.value,
              source,
            );
          }
          sendCommentCount(newCommentCount.value + topCommentCount.value);

          // standLocation.value = standData.value.location;

          postItemHeight.value =
            (titleBar.value?.offsetHeight || 0) + (titleBar.value?.offsetTop || 0);

          // 获取评论列表成功埋点
          commonCommentStat(20084682, {
            costTime: commonCostTime.value,
          });

          const durationTime = window.__TEMPLATE_COMMEMT_DATA__?.startTime
            ? Date.now() - window.__TEMPLATE_COMMEMT_DATA__.startTime
            : window.performance.now();

          window.generalPerfStat?.({ action: 'responseEnd', durationTime });
        })
        .catch((error) => {
          // 一点源下兜底请求出错后 updateArticleInfo 不执行问题
          setNewCount(0);

          const { code, message } = error;

          window.commentCommonHelps?.performanceStat?.('H5_commentViewsRenderComplete');
          // 获取评论列表失败埋点
          commonCommentStat(20084681, {
            errorMsg: message,
            errorCode: code,
          });

          console.log(code, message, 'error');
        });

      enableUsePreloadList();

      document.documentElement.dataset.styling = getColorOsVersion();

      if (limitedCommentScene()) {
        document.documentElement.dataset.styleType = 'not-video';
      }

      if (isArticle.value && wv.isMethodValid('BrowserIFlow.onScrollToTopModuleChanged')) {
        const el = document.querySelector('#cpc-comment-box') as HTMLElement;

        window.addEventListener(
          'scroll',
          useDebounceFn(() => {
            if (isPosVisible(el)) {
              wv.invoke('BrowserIFlow.onScrollToTopModuleChanged', 1);
            } else {
              wv.invoke('BrowserIFlow.onScrollToTopModuleChanged', 0);
            }

            onAnchorSliding(el);
          }),
        );
        wv.invoke('BrowserIFlow.onScrollToTopModuleChanged', 0);
        onAnchorSliding(el);
      }
    });

    const fetchCommentStat = (isLoadingState: boolean) => {
      isLoading.value = isLoadingState;
      const startTime = Date.now();
      // 获取评论列表埋点
      commonCommentStat(20084680);
      fetchComments()
        .then(() => {
          // 获取评论列表成功埋点
          commonCommentStat(20084682, {
            costTime: commonCostTime.value,
          });
          isLoading.value = false;
        })
        .catch((error) => {
          const { code, message } = error;

          // 获取评论列表失败埋点
          commonCommentStat(20084681, {
            errorMsg: message,
            errorCode: code,
          });

          const timeout = Date.now() - startTime > 300 ? 0 : Date.now() - startTime;
          setTimeout(() => {
            isLoading.value = false;
          }, timeout);

          console.log(code, message, 'fetch error');
        });
    };

    const commentSwitchStatus = ref(false);

    // const enableTopicCard = feature.value.enableTopicCard;
    // const enableTopicEntry = ref(false);

    getCommentSwitchStatus()
      .then((result: number) => {
        commentSwitchStatus.value = !!result;
      })
      .catch((error) => {
        console.log(error);
      });

    // getShelvesEnabled().then((result: boolean[]) => {
    //   const isArticleEntrance = result[0];
    //   const isSmallVideoEntrance = result[1];
    //   const isShortVideoEntrance = result[2];
    //   const isTopicCardEntrance = result[3];

    //   /** styleType
    //    * 1: 文章
    //    * 2: 短视频
    //    * 4: 小视频
    //    */
    //   enableTopicEntry.value =
    //     feature.value.enableTopicCard &&
    //     documentMeta.value.dataSource === 'oppo' &&
    //     ((documentMeta.value.styleType === 1 &&
    //       isArticleEntrance &&
    //       pageType.value === PageType.DEFAULT) ||
    //       (documentMeta.value.styleType === 2 && isShortVideoEntrance) ||
    //       (documentMeta.value.styleType === 4 && isSmallVideoEntrance)) &&
    //     !isShowAnnoucement.value;

    //   enableTopicEntry.value = feature.value.enableTopicEntry && isTopicCardEntrance;
    // });

    const canShowAnnouncement = computed(() => {
      return commentSwitchStatus.value;
    });

    const commentZone = ref(null);

    const isFirstEnter = ref(true);

    const isNoContent = computed(() => {
      return topComments.value.length === 0 && newComments.value.length === 0;
    });

    /**
     * == 小视频场景特殊逻辑 ==
     * 当有精彩评论+全部评论时，前端正常显示；但“全部评论”文案要改为“最新评论”
     * 当无精彩评论时，就同设计稿保持一致“全部评论”由客户端展示，前端去除
     */
    const isSmallVideoType = computed(() => {
      return parseInt(documentMeta.value.styleType as string) === 4;
    });

    // os版本获取
    const styling = computed(() => {
      return getColorOsVersion() !== '13';
    });

    /**
     * contentType
     *  1、仅在文章样式下的评论区显示标题栏
     *  2、仅在oppo源文章详情页下window.pageData获取
     *  3、其他均无法获取如：（一点源、小视频、短视频、全部评论页、二级回复页）
     * */
    const isArticle = computed(() => {
      return contentType || pageType.value === PageType.DEFAULT;
    });

    const noConnectionLottie = computed(() => {
      return getVersionLottieResource(getColorOsVersion(), isNightMode.value, 'noConnection');
      // return isNightMode.value ? noConnectionDark : noConnection;
    });

    const loadingErrorLottie = computed(() => {
      return getVersionLottieResource(getColorOsVersion(), isNightMode.value, 'error');
      // return isNightMode.value ? loadingErrorDark : loadingError;
    });

    const newTitleClass = computed(() => {
      return {
        'hide-title': topComments.value.length === 0 && isSmallVideoType.value,
      };
    });

    const hideTitleMarginTopClass = computed(() => {
      return {
        'hide-top': topComments.value.length === 0 && isSmallVideoType.value,
      };
    });

    const { onEnterCommentZone, onLeaveCommentZone } = useNativeAbility();

    if (limitedCommentScene()) {
      const { isInViewPort } = useIsInViewPort(commentZone);

      watch(isInViewPort, (value) => {
        if (value) {
          onEnterCommentZone();

          if (isFirstEnter.value) {
            console.log('阅读至评论区域-20083351');
            wv.asyncInvoke('generalStat', 20083351, 21006, 10012, JSON.stringify({}));
            isFirstEnter.value = false;
          }
        } else {
          onLeaveCommentZone();
        }
      });
    }

    const titleBar = ref(null);
    const commentTitleBar = 50; // 标题栏高度
    const announcementHeight = 65; // 公告区高度
    // const topicCardHeight = 216; // 公告区高度

    const commentBarStyle = computed(() => {
      return isNoContent.value && pageType.value === 1
        ? {
            height: `${
              window.innerHeight -
              (commentStatus.value == CommentStatus.DEFAULT ? 0 : announcementHeight)
              // (enableTopicCard && newLoadStatus.value !== LoadStatus.LOADING
              //   ? topicCardHeight
              //   : 0) -
            }px`,
            display: 'flex',
            'justify-content': 'center',
            'flex-direction': 'column',
            'min-height': '210px',
          }
        : {};
    });

    const noCommentStyle = computed(() => {
      return {
        height: `${window.innerHeight - announcementHeight}px`,
        display: 'flex',
        'max-height': pageType.value === PageType.DEFAULT ? '272px' : 'none',
        'justify-content': 'center',
        'flex-direction': 'column',
      };
    });

    const addCommentHandler = (params) => {
      onComment(params);
    };

    const newTitleName = computed(() => {
      return isSmallVideoType.value ? '最新评论' : '全部评论';
    });

    return {
      newComments,
      newLoadStatus,
      newCommentCount,

      topComments,
      topLoadStatus,
      topCommentCount,

      commentStatus,
      isLoading,

      fetchComments,
      fetchCommentStat,
      addCommentHandler,

      LoadStatus,
      CommentStatus,
      commentZone,
      titleBar,
      isArticle,

      newTitleClass,
      hideTitleMarginTopClass,

      newTitleName,
      isSmallVideoType,
      styling,

      commentBarStyle,
      noCommentStyle,
      isNoContent,

      canShowAnnouncement,

      noConnectionLottie,
      loadingErrorLottie,

      // enableTopicEntry,

      // enableTopicCard,

      // standLocation,
    };
  },
});
</script>

<style scoped lang="scss">
@import '../assets/css/common.scss';
@import '../assets/css/loading.scss';
@import '../assets/css/load-bar.scss';
@import '../assets/css/styling-mixin.scss';

.comment-zone {
  color: #000;

  .hide-title {
    font-size: 0;
    line-height: 0;
  }

  .hide-top {
    margin-top: 60px;
  }

  .scroll-load-more {
    overflow: hidden;
  }
}

.comments-name {
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  font-size: 48px;
  font-weight: 500;
  line-height: 111px;
  padding-left: 48px;
  color: rgba($color: #000, $alpha: 0.9);
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}

#top-comments-list {
  padding: 0;
  margin: 0;
}

#new-comments-list {
  padding: 0;
  margin: 0;
}

.comments-list {
  list-style: none;
}

html[data-theme='dark'] {
  .load-sofa {
    background: url('../assets/img/document_none_comment_dark.png') center center / contain
      no-repeat;
  }

  .no-network-connection {
    background: url('../assets/img/no-network-connection_dark.png') center center / contain
      no-repeat;
  }
}
</style>

<style lang="scss">
// .slot-wrap + .comment-item {
//   padding-top: 23px;
// }
// .comment-item + .slot-wrap {
//   padding-top: 23px;
// }
</style>
